import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
  loadingIndicator: {
    position: 'fixed',
    top: '50%',
    left: '50%',
  },
  bulletPoints: {
    height: '10vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

export default useStyles;
